<!--
 * @Author: wsx
 * @Date: 2022-01-05 18:45:47
 * @LastEditTime: 2022-01-12 18:03:34
 * @LastEditors: your name
 * @Description:车牌
-->
<template>
  <div
    class="HCarPlate"
    v-if="styleData"
    :style="{
      fontSize: fontSize,
      backgroundColor: styleData.remark,
      borderColor: styleData.remark,
    }"
  >
    <!-- {{ styleData }} -->
    <div
      class="content"
      :style="{ fontSize: fontSize, backgroundColor: styleData.remark }"
      :class="[
        {
          contentColor: styleData.code == '2' || styleData.code == '6',
        },
        {
          content99Color: styleData.code == '99',
        },
      ]"
    >
      <slot></slot>
    </div>
  </div>
</template>
<script>
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  watchEffect,
} from "vue";
import { getDict } from "@/api/constant";
export default defineComponent({
  name: "HCarPlate",
  components: {},
  props: {
    fontSize: {
      type: String,
      default: "16px",
    },
    // 图标的位置 left | right
    position: {
      type: String,
      default: "left",
    },
    type: {
      type: String,
      default: "2",
    },
    colorData: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const data = reactive({
      attr: [
        // { label: "黄", type: 6, color: "#ffcc00" },
        // { label: "绿", type: 9, color: "#36c13c" },
        // { label: "蓝", type: 5, color: "#188feb" },
        // { label: "白", type: 2, color: "#fff" },
        // { label: "黑", type: 1, color: "#333" },
        // { label: "黄绿", type: 80, color: "#d8ff00" },
        // { label: "渐变绿", type: 81, color: "#258c47" },
        // { label: "其他", type: 99, color: "#b2b2b2" },
      ],
      styleData: null,
      getAsync: false,
    });
    const getStyle = () => {
      let array = data.attr.filter((item) => {
        if (item.code == props.type) return item;
      });
      data.styleData = array[0];
    };

    const refData = toRefs(data);
    watchEffect(() => {
      if (!props.colorData) {
        data.getAsync = true;
      } else {
        data.attr = props.colorData;
        getStyle();
      }
    });

    // 获取数据字典
    const queryMenuType = async () => {
      const resCarColor = await getDict("car_card_color");
      data.attr = resCarColor.dict;
      getStyle();
    };
    onMounted(() => {
      if (data.getAsync) {
        queryMenuType();
      }
    });
    return { ...refData };
  },
});
</script>
<style lang="scss" scoped>
.HCarPlate {
  height: 36px;
  width: 107px;
  border: 2px solid;
  border-radius: 4px;
  cursor: pointer;
  .content {
    height: 32px;
    width: 104px;
    @include flex-row-c-c;
    border: 1px solid #fff;
    color: #fff;
    border-radius: 5px;
  }
  .contentColor {
    color: #333;
  }
  .content99Color {
    color: #e9353b;
  }
}
</style>
